import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import Link from '@material-ui/core/Link';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
	modalClassConDSI: {
		position: 'absolute',
		width: '96%',
		padding: '35px 15px 0px',
		right: 'auto',
		bottom: 'auto',
	},
	modalBoxContent: {
		maxHeight: '600px',
	},
	modalText: {
		position: 'absolute',
		top: '10px',
		right: '10px'
	},
}));

const DiscoverPatbaseModal = props => {
	const classes = useStyles();
	const toggle = useSelector(state => state.setToggle.toggle);

	return (
		<Modal
			size="lg"
			aria-labelledby="contained-modal-title-vcente"
			centered
			show={props.showModal}
			contentClassName={classes.modalClassConDSI}
		>
			<Link href="#" onClick={(e) => e.preventDefault()} className={classes.modalText}>
				<CloseIcon onClick={props.closeModal} />
			</Link>
			<div className={toggle? "jumbotron appTextColor": "jumbotronDark appTextColor" }>
				<p>Redirecting to Patbase in <b>{props.pbCountdown}</b> seconds ... </p>
				<p>Here is the Patent Number list (total {props.totalPatbasePns}):</p>
				{props.patbasePns.map(
					pn => (<div key={'pnlist_' + pn}>{pn}</div>)
				)}
				<br></br>
				<div>
					<button onClick={props.closeModal} className="pull-right large-button gqblue">OK</button>
				</div>
			</div>
			<form name="pb_pn_list" id="pb_pn_list" action="https://www.patbase.com/getimg/gq.php" method="POST" target="newWindow">
				<input type="hidden" name="pn" value={props.patbasePnsStr}/>
			</form>
		</Modal>
	);
}

export default DiscoverPatbaseModal;
